import { connect } from 'dva';
import React from 'react';
import { DIST_KEY } from 'src/common/models/config/index';
import { checkUrlPermission } from 'src/common/services/app';
import CheckPermissions, { needCheck } from './CheckPermissions';

@connect()
export default class Authorized extends React.Component {
  /**
   * url鉴权
   */
  componentDidMount() {
    const { pathname } = this.props.location;
    const arr = pathname?.split('/');
    let claimIndex = arr.findIndex(item => item === 'claim');
    if (claimIndex === -1) {
      claimIndex = 0;
    }
    this.props.dispatch({
      type: 'global/getDistConfig',
      payload: DIST_KEY,
    });
    // TODO获取按钮级别权限（取2小节）
    // 不合理 需要改 按正常的PageId 改 本期先白名单跳过
    if (pathname?.includes('spring-board/index')) {
      return;
    }
    this.props.dispatch({
      type: 'privileges/setElement',
      pageId: `/${arr[claimIndex + 1]}${arr[claimIndex + 2] ? '/' + arr[claimIndex + 2] : ''}`,
    });
  }
  urlAuthority = () => {
    const { pathname } = this.props.location;
    const prefix = '';
    if (!this.needCheckUrl()) {
      return Promise.resolve({
        result: {
          isPermit: true,
        },
      });
    }
    return checkUrlPermission({
      method: 'get',
      path: `/${prefix}${pathname.startsWith('/') ? pathname : `/${pathname}`}`,
    });
  };

  /**
   * 页面鉴权
   */
  pageAuthority = () => {
    const { pageId, dispatch } = this.props;

    if (!this.needCheckPage()) {
      return Promise.resolve();
    }
    return dispatch({
      type: 'privileges/fetchPagePermit',
      payload: {
        pageId,
      },
    });
  };

  isPromise = () => {
    if (this.needCheckUrl() || this.needCheckPage()) {
      return true;
    }
    return false;
  };

  needCheckUrl = () => {
    const { location } = this.props;
    const { pathname } = location;
    if (needCheck(pathname)) {
      return true;
    }
    return false;
  };

  needCheckPage = () => {
    const { pageId } = this.props;
    if (pageId) {
      return true;
    }
    return false;
  };

  render() {
    const { children, noMatch = null } = this.props;

    const childrenRender = typeof children === 'undefined' ? null : children;
    const isPromise = this.isPromise();
    const promise = [this.urlAuthority, this.pageAuthority];

    return CheckPermissions(childrenRender, noMatch, isPromise, promise);
  }
}
